import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Store } from '@ngxs/store';
import { Subject } from 'rxjs';
import { SaveDealStatus, SubscribeToDealStatus } from 'app/store/deal/deal/deal.actions';
import { DealStatusOptions } from 'app/models/dto/deal-status-options.model';

@Component({
  selector: 'app-deal-status-picker-smart',
  templateUrl: './deal-status-picker-smart.component.html'
})
export class DealStatusPickerSmartComponent implements OnInit, OnDestroy {

  @Input() dealId: number;
  @Input() status: string;
  @Input() statusOptions: DealStatusOptions[];
  destroyed$ = new Subject<boolean>();

  constructor(private store: Store) { }

  ngOnInit() {
    this.store.dispatch(new SubscribeToDealStatus(this.dealId));
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  handleStatusChange({ stage, status, reason = '', otherReason = [],  subReasons = []}) {
    this.store.dispatch(new SaveDealStatus(this.dealId, stage, status, reason, otherReason, subReasons));
  }
}
